module.exports = __webpack_public_path__ + "img/coup.c4771cbf.png";